import React from "react";

function Register() {
 
    
    return ( 
        <>

    
        </>
  );
};
export default Register;
